import heatmapSettings from './reducers';

export default heatmapSettings;
